import React from "react";

const { Provider, Consumer } = React.createContext({ form: undefined });

export { Provider, Consumer };
